/** Slug from the URL for loading landing page content. */
export function resolveLandingRouteSlug(route) {
    return route?.params?.slug || null;
}

/** API slug for loading landing page content from CMS. */
export function resolveLandingFetchSlug(routeSlug) {
    return routeSlug;
}
